import React from "react";
import { Link } from "react-router-dom";

export class IndexPage extends React.Component {
  render() {
    return (
      <div>
        <Link to='/auth'>Login</Link>
      </div>
    );
  }
}
